import React, { Component } from 'react'
import { Button, Icon } from 'antd'
import { services } from '@services/api'

export default class extends Component {
    constructor(props) {
        super(props)
        const { required_token, required_fields, id } = this.props.service //active name
        this.state = {
            id,
            required_token,
            required_fields: required_fields ? JSON.parse(required_fields) : null
        }
    }

    render() {
        const { required_token } = this.state
        return (
            <>
                <div
                    style={{
                        flexDirection: 'row',
                        display: 'flex',
                        position: 'relative',
                        justifyContent: 'space-around',
                        alignItems: 'center'
                    }}
                >
                    <div style={{ flexDirection: 'column', display: 'flex', position: 'relative' }}>
                        תשלום לאחר שירות?
                        <input
                            type="checkbox"
                            style={{ alignSelf: 'center', marginTop: 15 }}
                            checked={!!required_token}
                            onChange={() => this.setState({ required_token: +!required_token })}
                        />
                    </div>
                    {/* <div style={{ flexDirection: 'column', display: 'flex', position: 'relative' }}>
                    שדות דרושים:
                    ...required_fields...
                </div> */}
                    <Button
                        disabled={required_token === this.props.service.required_token}
                        style={{ marginTop: 35.5, width: 225 }}
                        onClick={() =>
                            services
                                .updateService({ ...this.state })
                                .then(() => {
                                    alert('שירות עודכן בהצלחה!')
                                    this.props.refreshServiceList()
                                })
                                .catch(err => {
                                    console.log({ err })
                                    alert('שגיאה בעדכון שירות')
                                })
                        }
                    >
                        שמור שינויים <Icon type="check" />
                    </Button>
                </div>
            </>
        )
    }
}
